var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-alert-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        staticClass: "el-alert",
        class: [_vm.typeClass, _vm.center ? "is-center" : ""],
        attrs: { role: "alert" }
      },
      [
        _vm.showIcon
          ? _c("i", {
              staticClass: "el-alert__icon",
              class: [_vm.iconClass, _vm.isBigIcon]
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "el-alert__content" },
          [
            _vm.title
              ? _c(
                  "span",
                  { staticClass: "el-alert__title", class: [_vm.isBoldTitle] },
                  [_vm._v(_vm._s(_vm.title))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default", [
              _vm.description
                ? _c("p", { staticClass: "el-alert__description" }, [
                    _vm._v(_vm._s(_vm.description))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "i",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.closable,
                    expression: "closable"
                  }
                ],
                staticClass: "el-alert__closebtn",
                class: {
                  "is-customed": _vm.closeText !== "",
                  "uk-icon-close": _vm.closeText === ""
                },
                on: {
                  click: function($event) {
                    _vm.close()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.closeText))]
            )
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6e53341b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6e53341b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./packages/alert/src/main.vue
// module id = 342
// module chunks = 0